import { render, staticRenderFns } from "./car-buy-upper.vue?vue&type=template&id=7fb5fedd"
import script from "./car-buy-upper.vue?vue&type=script&lang=js"
export * from "./car-buy-upper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default})
